module.exports = __webpack_public_path__ + "img/billing_cash_payment.f9c9ff1b.svg";